module.exports = __webpack_public_path__ + "static/media/share.fd489537.svg";